export default "__VITE_ASSET__CFidC0RT__"